import { gql } from "@apollo/client";

const MARK_POST_READ = gql`
  subscription markpostread {
    markpostread {
      agentId
      facebookPostId
      last_seen_at
    }
  }
`;

export default MARK_POST_READ;
